var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 15.713L18.0102 9.703L16.5972 8.288L12.0002 12.888L7.40423 8.288L5.99023 9.702L12.0002 15.713Z",
    fill: "#AEB1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDisable);
export default __webpack_public_path__ + "static/media/ArrowDownDisable.65dbd6cbde96befb738d97d9e6ff0f96.svg";
export { ForwardRef as ReactComponent };